export const FINANCE_CHARGE_MAX_VALUE = 999999999.99;
export const FINANCE_CHARGE_MAX_VALUE_ERROR =
	'A finance charge cannot be created for more than $999,999,999.99';
